import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BRAND_LOGOS } from '@app/constants/credit-card-logos';
import { AuthService } from '@app/services/auth.service';
import { Card } from '@models/settings/billing/card.model';

@Component({
    selector: 'app-payment-information',
    templateUrl: './payment-information.template.html',
    styleUrls: ['./payment-information.style.scss'],
})
export class PaymentInformationComponent implements OnInit {
    @Input() cards: Card[] | null = null;
    @Output() edit: EventEmitter<null> = new EventEmitter();

    isLoading = true;

    readonly BRAND_LOGOS = BRAND_LOGOS;

    constructor(public auth: AuthService) {}

    ngOnInit(): void {
        this.isLoading = false;
    }
}
